<template>
  <div class="checkpoint-message"
       :id="'chat-message-' + message.innerId">{{ message.data.text }}</div>
</template>

<script>
import IClassroom from '@/components/classroom/lib/IClassroom'

export default {
  props: ['message'],
  mounted () {
    this.message.offsetTop = this.$el.offsetTop
    this.message.estHeight = this.$el.offsetHeight

    IClassroom.requestNextMessage()
  }
}
</script>
<style lang="stylus" scoped>
.checkpoint-message {
  width 100%
  text-align center
  font-size 17px
  font-weight bold
  margin-bottom 1.5rem
}
</style>
